import React, { Component } from "react";
import { connect } from "react-redux";
import Filter from "../components/Filter";
import { changePeriod, setPeriodsItemSelected } from "../actions/stats";
import _ from "lodash";
import moment from "moment";

class PeriodsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: undefined
    };
  }

  onChange(v) {
    const { periods = [] } = this.props;
    const period = _.find(periods, { id: v });

    if (period && period.dates && period.dates.length === 2) {
      this.props.changePeriod([moment(period.dates[0]), moment(period.dates[1])]);
    }
    console.log("this.props.setPeriodsItemSelected", v);
    this.props.setPeriodsItemSelected(v);
    this.setState({
      value: v
    });
  }

  getPeriodsFormatted() {
    const { periods = [] } = this.props;
    const periodsFormatted = [];

    for (let i = 0; i < periods.length; i++) {
      const period = periods[i];
      const dates = period.dates || [];
      let date1 = "";
      let date2 = "";
      if (dates.length === 2) {
        date1 = moment(dates[0]).format("L");
        date2 = moment(dates[1]).format("L");
      }
      if (period.id && period.value) {
        periodsFormatted.push({
          id: period.id,
          value: `${period.value} : ${date1} - ${date2}`
        });
      }
    }

    return periodsFormatted;
  }

  render() {
    return (
      <div style={{ width: "90%" }}>
        <Filter
          value={this.props.periodsItemSelected}
          loading={false}
          data={this.getPeriodsFormatted()}
          placeholder={"Périodes commerciales"}
          onChange={v => {
            this.onChange(v);
          }}
          disabled={false}
          mode="default"
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    periods: state.stats.periods || [],
    periodsItemSelected: state.stats.periodsItemSelected
  };
};

export default connect(mapStateToProps, { changePeriod, setPeriodsItemSelected })(PeriodsContainer);



// WEBPACK FOOTER //
// src/modules/stats/containers/PeriodsContainer.js